import { createApiInstance } from './createApiInstance';
import { getRecaptchaToken } from './recaptcha';

const apiWithCaptcha = {

  post: async (url: string, payload = {}, auth: any = {}, action = 'submit') => {
    const api = await createApiInstance();
    const token = await getRecaptchaToken(action); // gerado AGORA → resolve expiração de 2 min
    const config = {
      ...auth,
      headers: {
        ...(auth?.headers || {}),
        ...(token ? { 'x-recaptcha-token': token } : {}),
      },
    };
    const response = await api?.post(url, payload, config);
    return response ? response : { data: {}, status: 404 };
  },

  get: async (url: string, params: any = {}, action = 'submit') => {
    const api = await createApiInstance();
    const token = await getRecaptchaToken(action);
    const config = {
      ...params,
      headers: {
        ...(params?.headers || {}),
        ...(token ? { 'x-recaptcha-token': token } : {}),
      },
    };
    const response = await api?.get(url, config);
    return response ? response : { data: {}, status: 404 };
  },

};

export default apiWithCaptcha;